import React from 'react';
import StringField from './StringField';

const NumberField = props => {
    return <StringField type={'number'} maxWidth={'30px'} {...props} min={0} />;
}

export default NumberField;